import {Button, Col, Form, Input, Modal, notification, Row, Select, Upload} from "antd"
import React, {useContext, useEffect, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {unwrapResult} from "@reduxjs/toolkit"
import {RootDispatch} from "../../app/store"
import {TabBar, TabPane} from "../../compnents/widgets/TabBar"
import styles from "../filingManagement/TenantInfo/teantInfo.module.css";
import axios from "axios";
import {AXIOS_IP, beforeUpload} from "../filingManagement/fileUploadService";
import {CloseOutlined, ExclamationCircleFilled, PlusOutlined} from "@ant-design/icons";
import {PreviewImgOrPdf} from "../filingManagement/Preview";
import {ThemeContext} from "../../theme/ThemeContext";
import {selectPhone, selectTenantName} from "../../app/applicationSlice";
import {isValidMobileNumber} from "../../utils/StringUtils";
import {getApiKeyAsync} from "../login/loglinSlice";
import {getSmsCodeForGetApiKey} from "../user/userSlice";

const DEVELOPER_NAMES = [
  '好医点',
  'E看牙',
  '牙医管家',
  'ABC',
  '创业',
  '中铂云',
  'SCSS润智慧HIS',
  '素灵AI',
  '励齿',
  '兴财',
  '得帆IPAAS',
  '杭州财康',
  '美亚美牙',
  '轻松牙医',
  '漪云',
  '自研系统',
  '其他',
]

export const ApiKey = () => {
  const dispatch = useDispatch<RootDispatch>()
  const theme = useContext(ThemeContext)
  const tenantName = useSelector(selectTenantName)
  const concatPhone = useSelector(selectPhone)
  const [form] = Form.useForm()
  const [visible, setVisible] = useState<any>(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [isOther, setIsOther] = useState(false)
  const [smsCountdown, setSmsCountdown] = useState(0)
  const [apiKeyText, setApiKeyText] = useState<string>()
  const [appSecret, setAppSecret] = useState<string>()
  const [developerSearch, setDeveloperSearch] = useState('')

  useEffect(() => {
    form.setFieldsValue({
      name: tenantName?.split('-')?.[0],
    })
  }, [])

  useEffect(() => {
    form.setFieldsValue({phone: concatPhone})
  }, [concatPhone])

  useEffect(() => {
    if (smsCountdown <= 0) {
      return
    }
    const timer = setTimeout(() => {
      setSmsCountdown(smsCountdown - 1)
    }, 1000)
    return () => clearTimeout(timer)
  }, [smsCountdown])

  // 获取短信验证码
  const handleGetSmsCode = async () => {
    if (smsCountdown > 0) {
      return
    }
    if (!isValidMobileNumber(concatPhone)) {
      notification.error({message: '手机号码格式不正确', duration: 3})
      return
    }
    try {
      await dispatch(getSmsCodeForGetApiKey(concatPhone)).then(unwrapResult)
      setSmsCountdown(60)
      notification.success({message: '验证码已发送', duration: 3})
    } catch {
      // 错误提示已由 sendAsync 统一处理
    }
  }
  return (
    <>
      <TabBar
        className={styles.tabs}
      >
        <TabPane tab="秘钥管理" key="0">
          <Col className={styles.content}>
            <Col
              style={{
                flex: 1,
                backgroundColor: theme.pn,
                borderRadius: 10,
                display: "flex",
                flexDirection: "column",
                padding: "10px 20px",
              }}
            >
              <Row>机构名称：{tenantName?.split('-')?.[0]}</Row>
              <Row>接口密钥：<a type="primary" onClick={() => {
                setVisible(true)
              }}>点击获取</a></Row>
            </Col>
          </Col>
        </TabPane>
      </TabBar>

      <Modal
        title="信息登记"
        width={600}
        visible={visible}
        onCancel={() => {
          setVisible(false)
          setIsOther(false)
        }}
        onOk={form.submit}
        okText="确定"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div>
          <Form
            form={form}
            labelCol={{span: 6}}
            wrapperCol={{span: 18}}
            onFinish={async (vs) => {
              if(vs?.thirdPartyName =='好医点' || vs?.otherThirdPartyName == '好医点'){
                Modal.confirm({
                  centered: true,
                  title: "提醒",
                  content: (
                    <div>
                      好医点系统无需手动对接，如您选择了好医点系统，系统会自动完成对接，更多细节可以咨询服务人员。
                    </div>
                  ),
                  okText: "好的",
                  icon: null,
                })
                return;
              }
              setConfirmLoading(true)
              try {
                const data = await dispatch(getApiKeyAsync(vs)).then(unwrapResult)
                setVisible(false)
                setIsOther(false)
                form.setFieldsValue({smsCode: undefined})
                setApiKeyText(data?.appKey)
                setAppSecret(data?.appSecret)
              } catch {
                // 错误提示已由 sendAsync 统一处理
              } finally {
                setConfirmLoading(false)
              }
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="机构名称"
                >
                  <Input allowClear disabled/>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="选择开发商"
                  name="thirdPartyName"
                  rules={[
                    {required: true, message: "请选择您的对接开发商"},
                  ]}
                >
                  <Select
                    placeholder='开发商名称'
                    allowClear
                    onChange={(value) => {
                      setIsOther(value === "其他")
                      if (value !== "其他") {
                        form.setFieldsValue({otherThirdPartyName: undefined})
                      }
                    }}
                    showSearch
                    onSearch={setDeveloperSearch}
                    filterOption={false}
                    // suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  >
                    {DEVELOPER_NAMES.filter((name) =>
                      developerSearch &&
                      name.toLowerCase().includes(developerSearch.toLowerCase())
                    ).map((name) => (
                      <Select.Option key={name} value={name}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {isOther && (
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="开发商名称"
                    name="otherThirdPartyName"
                    rules={[
                      {required: true, message: "请输入开发商名称"},
                      {min: 2, message: "开发商名称最少2个字"},
                    ]}
                  >
                    <Input placeholder="请输入开发商名称" allowClear/>
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row>
              <Col span={24}>
                <Form.Item
                  name="phone"
                  label="手机号码"
                >
                  <Input disabled/>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="smsCode"
                  label="短信验证码"
                  rules={[
                    {required: true, message: "请输入短信验证码"},
                  ]}
                >
                  <Input
                    placeholder="请输入验证码"
                    maxLength={6}
                    suffix={
                      <a
                        style={{cursor: smsCountdown > 0 ? "not-allowed" : "pointer"}}
                        onClick={handleGetSmsCode}
                      >
                        {smsCountdown > 0 ? `重新获取(${smsCountdown}s)` : "获取验证码"}
                      </a>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title="接口密钥"
        width={400}
        visible={!!apiKeyText}
        onCancel={() => {
          setApiKeyText(undefined)
        }}
        footer={null}
        centered
        maskClosable={false}
      >
        <div style={{wordBreak: 'break-all'}}>
          <p>请妥善保管对接密钥</p>
          <p>appKey = {apiKeyText}</p>
          <p>appSecret = {appSecret}</p>
        </div>
      </Modal>
    </>
  )
}
